"use client";
import { Brain, Globe, Layers, Zap } from "lucide-react";
import { useTranslations } from "next-intl";

export function WhyUseSection() {
	const t = useTranslations("aiDescribeImage.client.whyUse");

	return (
		<div className="w-full px-6 py-20">
			<h2 className="text-3xl font-bold text-center mb-10 bg-gradient-to-r from-indigo-500 to-purple-600 bg-clip-text text-transparent">
				{t("title")}
			</h2>

			<div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 max-w-6xl mx-auto">
				<div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 border border-gray-100 transform hover:scale-105">
					<div className="flex flex-col items-start">
						<div className="flex items-center gap-4 mb-3">
							<div className="bg-blue-50/50 p-3 rounded-full w-12 h-12 flex items-center justify-center">
								<Brain className="h-6 w-6 text-indigo-500" />
							</div>
							<h3 className="text-2xl font-semibold text-slate-800">
								{t("accurateAnalysis.title")}
							</h3>
						</div>
						<p className="text-slate-600 text-base leading-relaxed">
							{t("accurateAnalysis.description")}
						</p>
					</div>
				</div>

				<div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 border border-gray-100 transform hover:scale-105">
					<div className="flex flex-col items-start">
						<div className="flex items-center gap-4 mb-3">
							<div className="bg-blue-50/50 p-3 rounded-full w-12 h-12 flex items-center justify-center">
								<Layers className="h-6 w-6 text-indigo-500" />
							</div>
							<h3 className="text-2xl font-semibold text-slate-800">
								{t("comprehensiveImageToText.title")}
							</h3>
						</div>
						<p className="text-slate-600 text-base leading-relaxed">
							{t("comprehensiveImageToText.description")}
						</p>
					</div>
				</div>

				<div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 border border-gray-100 transform hover:scale-105">
					<div className="flex flex-col items-start">
						<div className="flex items-center gap-4 mb-3">
							<div className="bg-blue-50/50 p-3 rounded-full w-12 h-12 flex items-center justify-center">
								<Globe className="h-6 w-6 text-indigo-500" />
							</div>
							<h3 className="text-2xl font-semibold text-slate-800">
								{t("multilingualSupport.title")}
							</h3>
						</div>
						<p className="text-slate-600 text-base leading-relaxed">
							{t("multilingualSupport.description")}
						</p>
					</div>
				</div>

				<div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 border border-gray-100 transform hover:scale-105">
					<div className="flex flex-col items-start">
						<div className="flex items-center gap-4 mb-3">
							<div className="bg-blue-50/50 p-3 rounded-full w-12 h-12 flex items-center justify-center">
								<Zap className="h-6 w-6 text-indigo-500" />
							</div>
							<h3 className="text-2xl font-semibold text-slate-800">
								{t("fastResults.title")}
							</h3>
						</div>
						<p className="text-slate-600 text-base leading-relaxed">
							{t("fastResults.description")}
						</p>
					</div>
				</div>
			</div>
		</div>
	);
}
